module.exports = "/images/plus.svg?5424b432500c38ea06695a6881d8ebb6";